import {useMutation, useQuery} from "@tanstack/react-query";
import { api } from "services/api";

const QUERY_KEYS = ['users/accountconnect'];

export const useGetUsersAccountConnect = () => {
  const {isLoading, error, data} = useQuery({
    queryKey: ['users/accountconnect'],
    queryFn: () =>
      api.get(`users/accountconnect`)
  });
  return {isLoading, error, data};
};

export const usePostUsersAccountConnect = () => {
  const {isLoading, error, isSuccess, mutate} = useMutation({
    mutationFn: (discordId: any) =>
      api.post(`users/accountconnect`, {
        serviceToConnect: 'DISCORD',
        connectedAccountId: discordId
      })
  });
  return {isLoading, error, isSuccess, mutate};
};
